module.exports = __webpack_public_path__ + "img/double_occupancy.088da263.webp";